module.exports = __webpack_public_path__ + "img/1.da8fa4a6.jpeg";